// ProductOptionsModal.jsx
import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col, Image } from "react-bootstrap";
// @ts-ignore
import "../../styles/pos.css";
import { Cash, CreditCard } from "react-bootstrap-icons";
import mpesa from "../../assets/images/icons8-mpesa.svg";

/**
 *
 * @param {{show: boolean, onCancel: () => void, }} args
 */

export default function PaymentOptionsModal({
  show,

  onCancel,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered contentClassName="pom-modal">
      <div className="pom-title">SELECT PAYMENT METHOD</div>

      <div className="pom-payment">
        <button className="pom-pay-btn" onClick={() => {}}>
          <Cash size={30} />
          <span>CASH</span>
        </button>

        <button className="pom-pay-btn" onClick={() => {}}>
          <Image src={mpesa} />
          <span>M-PESA</span>
        </button>
        <button className="pom-pay-btn" onClick={() => {}}>
          <CreditCard size={30} />
          <span>CREDIT</span>
        </button>
      </div>

      <div className="pom-footer">
        <button className="pom-cancel" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </Modal>
  );
}
